export function toggleScroll(noScroll) {
    const siteBody = document.body;
    siteBody.classList.toggle("noScroll", noScroll);
}
